/* 🤖 this file was generated by svg-to-ts */
export const iconStore: {
    name: 'store';
    data: string;
} = {
    name: 'store',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20"><path fill="#000" fill-rule="evenodd" d="M1.13 19.979a.65.65 0 0 1-.65-.65V7.085a.65.65 0 0 1 .239-.504L8.589.167a.65.65 0 0 1 .821 0l7.871 6.414a.65.65 0 0 1 .24.504V19.33a.65.65 0 0 1-.65.65ZM9 1.509 1.779 7.394v11.285h3.298V11.2a.65.65 0 0 1 .555-.643l.096-.007h6.544a.65.65 0 0 1 .65.65v7.476h3.298V7.394zm2.62 10.342H6.378v6.827h5.244z"/></svg>`
};
